/** Affichage référence commande (#CMD-YYYY-NNNN). Anciens ORD- → CMD- à l’écran. */
export function formatOrderReference(
  reference: string | null | undefined,
  id: string | null | undefined,
): string {
  const idPart = id?.trim() ? id.trim().slice(0, 8) : '????';
  let raw = (reference?.trim() || idPart).trim();
  if (raw.startsWith('ORD-')) raw = `CMD-${raw.slice(4)}`;
  return raw.startsWith('#') ? raw : `#${raw}`;
}

/** Sans préfixe # (PDF, notifications, exports). */
export function formatOrderReferencePlain(reference: string | null | undefined, id: string): string {
  return formatOrderReference(reference, id).replace(/^#/, '');
}

/** Clé de recherche / filtre (sans #, minuscules). */
export function orderReferenceSearchKey(reference: string | null | undefined, id: string): string {
  return formatOrderReferencePlain(reference, id).toLowerCase();
}
